import React from 'react';
import { useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const location = useLocation();
  const showHeader = location.pathname === '/my';

  if (!showHeader) return null;

  return (
    <div className="xlx-header-sticky">
      <div className="xlx-header-fixed-box">
        <div className="left"></div>
        <div className="center">我的</div>
      </div>
    </div>
  );
};

export default Header;